const en = {
  services: {
    seoTitle: "Services · Hotel Ciutat Martorell in Martorell",
    seoDesc: "All hotel and room services: Business Corner, My Bar restaurant, parking, gym, free WiFi, 24h reception and much more.",
    eyebrow: "Services",
    title: "Everything you need for a comfortable stay",
    hotelTitle: "Hotel services",
    hotel: [
      "Air conditioning and heating",
      "Lifts",
      "Daily breakfast buffet",
      "Business Corner",
      "Luggage storage",
      "Gym",
      "Audiovisual equipment",
      "Parking",
      "24h reception",
      "My Bar restaurant, open every day for lunch and dinner",
      "24h room service",
      "Meeting and banquet rooms",
      "Laundry / dry-cleaning service",
      "Printing service",
      "Free WiFi",
    ],
    roomsTitle: "In the room",
    rooms: [
      "Adapted for guests with reduced mobility",
      "Individual air conditioning and heating",
      "Bathroom amenities",
      "Full bathroom with shower or bathtub and/or bidet",
      "Desk",
      "Minibar",
      "Hairdryer",
      "Flat-screen TV with USB input",
      "Telephone in room and bathroom",
      "Free WiFi",
      "Cot available",
      "Extra bed",
      "Non-smoking rooms",
    ],
    fitness: {
      eyebrow: "Gym",
      title: "Fitness room",
      text: "Keep up your routine during your stay in our fitness room, equipped with a treadmill, exercise bike and dumbbells.",
      alts: ["Fitness room with exercise bike, treadmill and towels", "Fitness room with treadmill, bike and dumbbells facing the mirror"],
    },
    shop: {
      eyebrow: "Official merchandise",
      title: "Football passion, right at reception",
      text: "At our reception you'll find official FC Barcelona and Real Madrid merchandise. Take your team's passion home with you.",
      note: "Available at reception only",
      cta: "Ask at reception",
      clubs: [
        { name: "FC Barcelona", items: "Shirts, caps, scarves, backpacks, balls and much more." },
        { name: "Real Madrid", items: "Shirts, kits, caps, balls, scarves and much more." },
      ],
    },
  },
  nav: {
    nye: "New Year's Eve 2026",
    hotel: "The Hotel",
    rooms: "Rooms",
    services: "Services",
    corporate: "Business & Meetings",
    events: "Events & Weddings",
    restaurant: "Restaurant",
    location: "Location",
    biosphere: "Sustainability",
    gallery: "Gallery",
    blog: "Blog",
    contact: "Contact",
    book: "Book direct",
    menu: "Menu",
    close: "Close",
    call: "Call",
    map: "Map",
    bookShort: "Book",
  },
  hero: {
    availability: "Check availability",
    checkin: "Check-in",
    checkout: "Check-out",
    adults: "Adults",
    children: "Children",
    promo: "Promo code",
    promoPlaceholder: "Optional",
    bestPrice: "Best price guaranteed when booking here",
    scroll: "Scroll",
  },
  attrs: [
    { t: "Best price guaranteed", d: "When booking direct" },
    { t: "Flexible cancellation", d: "Depending on rate" },
    { t: "Buffet breakfast", d: "06:30 to 10:30" },
    { t: "Private parking", d: "Surcharge applies, subject to availability" },
    { t: "100 m to Renfe & FGC", d: "30 min to Barcelona" },
  ],
  marquee: ["Martorell", "30 min Barcelona", "Montserrat", "Renfe & FGC 100 m away", "SEAT-CUPRA business area", "4-star comfort", "92 rooms", "Book direct"],
  home: {
    presEyebrow: "The hotel",
    stats: [
      { n: "92", l: "standard rooms" },
      { n: "100 m", l: "from Renfe and FGC" },
      { n: "30 min", l: "from Barcelona and the airport" },
      { n: "180", l: "guests in the main ballroom" },
    ],
    roomsEyebrow: "Rooms",
    roomsTitle: "Rest, tailored",
    roomsText: "Two room types designed for business travellers, families and long stays.",
    roomsCta: "See all rooms",
    from: "From",
    detail: "View details",
    corpEyebrow: "Business & meetings",
    corpTitle: "A corporate hub|5 minutes from SEAT-CUPRA",
    corpFeatures: ["3 meeting rooms", "Up to 180 guests", "WiFi connection and AV equipment", "Coffee breaks and executive lunches"],
    corpCta: "Request a quote",
    corpSecondary: "See meeting rooms",
    restEyebrow: "Gastronomy",
    restCta: "Discover the restaurant",
    locEyebrow: "Location",
    locCta: "How to get here",
    galleryEyebrow: "Gallery",
    galleryCta: "See full gallery",
    directEyebrow: "Direct booking",
    directTitle: "Booking here always pays off",
    directItems: [
      { t: "Best online price", d: "No agency will offer you a lower rate than our website." },
      { t: "Flexible terms", d: "Rates with free cancellation and payment at the hotel." },
      { t: "Direct contact", d: "You talk to the hotel team, no intermediaries, before and after your stay." },
      { t: "Welcome touches", d: "Late check-out subject to availability and exclusive perks for direct guests." },
    ],
    testimonialsEyebrow: "Reviews",
    testimonials: [
      { q: "Perfect location for working in the industrial area. Quiet rooms and a full breakfast. We come back every month.", a: "Marc V.", r: "Business trip" },
      { q: "We celebrated our daughter's communion in the ballroom and everything was flawless. The team took care of every detail.", a: "Laura & Jordi", r: "Family celebration" },
      { q: "Train 2 minutes away on foot and Barcelona in half an hour. A calm, well-kept base to visit the city and Montserrat.", a: "Claire D.", r: "Getaway" },
    ],
    contactEyebrow: "Let's talk",
    contactCta: "Contact us",
    rfpCta: "Request a quote",
  },
  rooms: {
    eyebrow: "Rooms",
    surface: "Size",
    occupancy: "Occupancy",
    bed: "Bed",
    bath: "Bathroom",
    features: "Amenities",
    guests: "guests",
    book: "Book this room",
    all: "All rooms",
    photosEyebrow: "Gallery",
    photosTitle: "Room & bathroom",
    photosCount: "photos",
    featureLabels: {
      wifi: "High-speed Wi-Fi",
      ac: "Air conditioning",
      tv: "TV",
      desk: "Work desk",
      minibar: "Minibar",
      hairdryer: "Hairdryer",
      crib: "Crib available",
      extra_bed: "Extra bed",
      accessible: "Accessible",
      nonsmoking: "Non-smoking",
    },
    servicesEyebrow: "Services",
    family: {
      eyebrow: "Travelling with family",
      title: "Family options",
      beds: { t: "Extra bed (triple)", d: "Turn your room into a triple with an extra bed. Free for children under 12." },
      crib: { t: "Free cot", d: "Cots available at no extra cost for the little ones." },
      note: "Both options are subject to availability; please request them in advance when booking.",
    },
    servicesTitle: "We have everything you need",
    services: [
      { t: "Buffet breakfast", d: "Local produce, artisan pastries and healthy options every morning." },
      { t: "Private parking", d: "Surcharge applies, subject to availability." },
      { t: "Fibre Wi-Fi", d: "Symmetric connection throughout the hotel, at no extra cost." },
      { t: "24 h reception", d: "Team available at any time for whatever you need." },
      { t: "Fitness room", d: "Keep up your routine during your stay." },
      { t: "Restaurant & bar", d: "Executive menu, Mediterranean à la carte and relaxed drinks." },
    ],
    notFound: "Room not found",
  },
  corporate: {
    eyebrow: "Business",
    title: "Your base of operations in the Llobregat industrial corridor",
    pillars: [
      { t: "Corporate rates", d: "Negotiated prices for companies with frequent stays and centralised invoicing." },
      { t: "Meeting rooms", d: "Three modular spaces, from 12 to 180 people." },
      { t: "Work and rest", d: "Desk in every room, Wi-Fi and early breakfast." },
      { t: "Executive catering", d: "Coffee breaks, working lunches and team dinners at the hotel." },
    ],
    salasEyebrow: "Meeting rooms",
    photosTitle: "Room & events",
    salasTitle: "Spaces that adapt to your agenda",
    salasCta: "See all rooms and capacities",
    formEyebrow: "Corporate rate",
    formTitle: "Request your corporate rate",
    formText: "Tell us how many nights a year your team needs and we will prepare a proposal within 24 hours.",
    capacityTitle: "Capacity by layout",
    capacityLabels: { teatro: "Theatre", escuela: "Classroom", u: "U-shape", imperial: "Boardroom", coctel: "Cocktail", banquete: "Banquet" },
    equipmentLabels: {
      wifi: "Fibre Wi-Fi", proyector: "Projector & screen", flipchart: "Flipchart", pizarra: "Whiteboard",
      coffee_break: "Coffee break", agua: "Mineral water", escritura: "Stationery", luz_natural: "Natural light", panelable: "Partitionable",
    },
    area: "Area",
    people: "pax",
    upTo: "Up to",
    requestRoom: "Request a quote for this room",
    salasIntro: "All rooms feature fibre Wi-Fi, independent climate control, AV equipment and coffee break service. We help you choose the ideal layout.",
    servicesTitle: "Services for your event",
    services: ["Welcome and mid-morning coffee break", "Executive lunch or working buffet", "Accommodation for speakers and attendees", "Parking for attendees", "Technical support during the event", "Secretariat and stationery"],
    otherRooms: "Other rooms",
    notFound: "Room not found",
  },
  events: {
    eyebrow: "Events & celebrations",
    title: "Big days deserve a place to match",
    intro: "Weddings, communions, anniversaries and group gatherings in a 220 m² ballroom with natural light, in-house kitchen and 92 rooms so nobody has to drive home.",
    types: [
      { key: "weddings", t: "Weddings", d: "Banquets for up to 150 guests, welcome cocktail and complimentary bridal suite.", cta: "Discover weddings" },
      { key: "celebrations", t: "Celebrations", d: "Communions, christenings, birthdays and anniversaries with tailored menus for all ages.", cta: "See celebrations" },
      { key: "groups", t: "Groups", d: "Sports teams, organised trips and Montserrat pilgrims with special conditions.", cta: "Groups & travel" },
    ],
    stepsEyebrow: "How we do it",
    steps: [
      { t: "We meet", d: "Visit the hotel, we listen to your idea and propose spaces and menus." },
      { t: "Tailored proposal", d: "Fixed quote within 48 h, no surprises, with a tasting session for weddings." },
      { t: "The big day", d: "A dedicated coordinator manages timings and suppliers so you just enjoy." },
    ],
    formEyebrow: "Tell us about your event",
    formTitle: "Let's start planning",
    weddings: {
      title: "Weddings in Martorell, half an hour from Barcelona",
      intro: "A partitionable ballroom with natural light for the banquet, a terrace for the cocktail and rooms for the couple and their guests. In-house Mediterranean kitchen and a dedicated coordinator from the first coffee to the last dance.",
      includes: ["Welcome cocktail", "Banquet with prior tasting menu", "Complimentary bridal suite", "Special rates for guests", "Optional open bar and DJ"],
    },
    celebrations: {
      title: "Communions, christenings and anniversaries",
      intro: "Family celebrations with menus designed for adults and children, space for kids' entertainment and the peace of mind of having everything under one roof.",
      includes: ["Children's and adult menus", "Space for entertainment", "Tailored decoration", "Personalised cake", "Photo area", "Rooms for relatives"],
    },
    groups: {
      title: "Groups, teams and organised trips",
      intro: "Accommodation for groups of 10 to 180 people with early breakfast, group dinners and fast check-in. The ideal starting point for Montserrat and Barcelona.",
      includes: ["Group rates from 10 rooms", "Early breakfast on request", "Group dinners and picnics", "Group check-in"],
    },
    includesTitle: "Included in the proposal",
    back: "All events",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "Mediterranean market cuisine",
    hoursTitle: "Opening hours",
    breakfast: "Breakfast",
    lunch: "Lunch",
    dinner: "Dinner",
    menuEyebrow: "Offer",
    menus: [
      { t: "Buffet breakfast", d: "Artisan pastries, fresh fruit, Catalan cold cuts, eggs cooked to order and speciality coffee.", p: "06:30 – 10:30" },
      { t: "Executive menu", d: "Monday to Friday at lunchtime. Three market courses with bread, drink and coffee.", p: "Ask for price" },
      { t: "Mediterranean à la carte", d: "Rice dishes, fish of the day, grilled meats and homemade desserts with Penedès wines.", p: "Dinners and weekends" },
      { t: "Group menus", d: "Set proposals for companies, celebrations and travel groups from 10 diners.", p: "Tailored" },
    ],
    reserveTitle: "Book a table",
    reserveText: "Call us and we will confirm your table right away.",
    reserveCta: "Call the restaurant",
    reserveTap: "Tap to call",
    wineEyebrow: "Cellar",
    wineTitle: "Wines from Penedès and all Catalonia",
    wineText: "A short, honest list that prioritises small wineries from the region: cavas, xarel·los and grenaches to accompany seasonal cooking.",
  },
  location: {
    eyebrow: "Location & connectivity",
    title: "At the centre of everything that matters",
    pois: [
      { name: "Renfe / FGC Martorell Enllaç station", dist: "100 m", time: "2 min walk", mode: "walk" },
      { name: "SEAT-CUPRA headquarters and industrial parks", dist: "2.5 km", time: "5 min by car", mode: "car" },
      { name: "Montserrat Monastery and Natural Park", dist: "19 km", time: "20 min by car / rack railway", mode: "car" },
      { name: "Barcelona city centre (Pl. Espanya / Catalunya)", dist: "28 km", time: "30 min by direct train or A-2", mode: "train" },
      { name: "Barcelona-El Prat Airport (BCN)", dist: "32 km", time: "25 min by motorway", mode: "plane" },
      { name: "Circuit de Barcelona-Catalunya", dist: "45 km", time: "40 min via AP-7", mode: "car" },
    ],
    faqEyebrow: "FAQ",
    faqTitle: "Getting here and around",
    mapCta: "Open in Google Maps",
    addressTitle: "Address",
    transportTitle: "Transport",
    transportItems: [
      { t: "By train", d: "Renfe R4 and FGC (Martorell Enllaç / Martorell Central) 100 m away. Barcelona in 30 min." },
      { t: "By car", d: "Direct exits from the A-2 (exit 585 Martorell) and the AP-7 (exit 25 Martorell)." },
      { t: "From the airport", d: "25 minutes by motorway. Taxi or car rental recommended." },
    ],
  },
  gallery: {
    eyebrow: "Gallery",
    title: "The hotel, in pictures",
    all: "All",
    cats: { habitaciones: "Rooms", restaurante: "Restaurant", salas: "Meeting rooms", eventos: "Events", fitness: "Fitness room", comunes: "Common areas" },
  },
  blog: {
    eyebrow: "Blog & guides",
    title: "Martorell, Barcelona and Montserrat, unhurried",
    read: "min read",
    readMore: "Read article",
    back: "Back to blog",
    related: "Related articles",
    notFound: "Article not found",
  },
  contact: {
    eyebrow: "Contact",
    title: "Let's talk about your stay or your event",
    text: "We reply within 24 working hours. For room bookings, please use our direct booking engine with best price guaranteed.",
    phone: "Phone",
    email: "Email",
    address: "Address",
    hours: "24-hour reception",
    formEyebrow: "Form",
    formTitle: "How can we help?",
  },
  form: {
    type: "Request type",
    types: { contacto: "General enquiry", empresa: "Corporate rate", salas: "Meeting room quote", evento: "Wedding / celebration / group", restaurante: "Restaurant booking" },
    name: "Full name",
    company: "Company / organisation",
    email: "Email",
    phone: "Phone",
    nights: "Nights per year (approx.)",
    guests: "People / diners",
    date: "Expected date",
    attendees: "Number of attendees",
    eventType: "Event type",
    eventTypes: ["Wedding", "Communion / christening", "Anniversary / birthday", "Meeting / training", "Convention", "Travel group", "Other"],
    setup: "Preferred layout",
    setups: ["Theatre", "Classroom", "U-shape", "Boardroom", "Cocktail", "Banquet"],
    catering: "Catering",
    caterings: ["Coffee break", "Executive lunch", "Dinner", "No catering"],
    lodging: "Do you need accommodation?",
    lodgings: ["Yes", "No", "To be confirmed"],
    message: "Comments",
    messagePlaceholder: "Tell us what you need…",
    consent: "I have read and accept the privacy policy and the processing of my data to handle this request.",
    submit: "Send request",
    sending: "Sending…",
    success: "Request sent. We will reply within 24 h.",
    error: "Could not send. Please try again or call us.",
    required: "Required field",
    invalidEmail: "Invalid email",
    consentRequired: "You must accept the privacy policy",
    select: "Select",
  },
  footer: {
    tagline: "4-star hotel in Martorell. Rest, work and celebrations 30 minutes from Barcelona.",
    explore: "Explore",
    business: "Business",
    guides: "Guides",
    legal: "Legal",
    contact: "Contact",
    legalNotice: "Legal notice",
    privacy: "Privacy",
    cookies: "Cookies",
    cookieSettings: "Cookie settings",
    rights: "All rights reserved.",
    registration: "Tourism registry",
    newsletter: "Receive direct offers",
    newsletterText: "We only write when there is something worth it.",
    subscribe: "Subscribe",
    subscribed: "Thank you, we will keep you posted.",
    directBook: "Direct booking · Best price guaranteed",
  },
  legal: {
    legal: { title: "Legal notice", date: "October 2026", sections: [
      ["Identifying information", "In compliance with Law 34/2002, of 11 July, on Information Society Services and Electronic Commerce (LSSI-CE), the following information is provided:\nOwner: EYE STAR, S.L.\nTrade name: Hotel Ciutat Martorell\nTax ID (NIF): B87171740\nRegistered office: Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), Spain\nEstablishment address: Avda. Pau Claris, s/n, 08760 Martorell (Barcelona), Spain\nPhone: +34 937 745 160\nEmail: info@hotel-martorell.com\nWebsite: www.hotel-martorell.com\nRegistration details: Commercial Registry of Madrid, Volume 32963, Folio 138, Sheet M-593334, 1st entry."],
      ["Purpose", "This Legal Notice governs the access, browsing and use of the website www.hotel-martorell.com, as well as the liabilities arising from the use of its contents and, where applicable, of the services that may be offered through it.\nAccessing and browsing the website grant the status of user and imply acceptance of the conditions set out in this Legal Notice."],
      ["Conditions of use", "The user undertakes to use the website in accordance with current legislation, good faith, public order and this Legal Notice.\nThe user must refrain from using the website for unlawful purposes or purposes contrary to this Legal Notice, as well as from carrying out any action that may damage, disable, overload or impair the website, its contents or the systems and equipment supporting it."],
      ["Intellectual and industrial property", "All contents of the website, including, by way of example and without limitation, texts, photographs, images, graphics, logos, icons, design, structure, source code and other elements that form part of the website, are owned by EYE STAR, S.L. or are used with the corresponding authorisation of their legitimate owners.\nSuch contents are protected by current intellectual and industrial property regulations.\nThe reproduction, distribution, public communication, transformation or any other form of exploitation, total or partial, of the website's contents without the prior and express authorisation of EYE STAR, S.L. is prohibited, except in legally permitted cases."],
      ["Liability", "EYE STAR, S.L. will endeavour to keep the website's contents correct and up to date. However, it does not guarantee the absence of errors or omissions, nor is it liable for any damages that may arise from the use of the information contained on the website when these result from circumstances beyond its control.\nEYE STAR, S.L. does not guarantee the availability and continuity of the website's operation either, and interruptions may occur for technical or maintenance reasons or due to circumstances beyond its control.\nThe website may contain links to third-party websites. EYE STAR, S.L. assumes no responsibility for the contents, services, operation or privacy policies of such external websites."],
      ["Personal data protection", "The processing of personal data that may be collected through this website will be carried out in accordance with current personal data protection regulations.\nInformation regarding the data controller, the purposes of processing, the legal bases, the recipients, the retention periods and the rights that users may exercise is available in the website's Privacy Policy."],
      ["Cookies", "This website may use cookies and similar technologies.\nInformation regarding the cookies used, their purposes, any third parties that may be involved and the way in which the user can manage their preferences is available in the Cookie Policy.\nCookies that are not strictly necessary will be used in accordance with the applicable regulations and, where necessary, after obtaining the user's consent."],
      ["Commercial communications", "Where the user has given consent to receive commercial communications by electronic means, these will be carried out in accordance with current legislation.\nThe user may object to the sending of commercial communications at any time by means of the mechanisms provided for this purpose in each communication."],
      ["Modifications", "EYE STAR, S.L. reserves the right to modify, update or remove, at any time and without prior notice, the contents and services offered through the website, as well as this Legal Notice.\nThe modifications will apply from the moment of their publication on the website."],
      ["Applicable law and jurisdiction", "The relationship between EYE STAR, S.L. and the user will be governed by Spanish law.\nFor the resolution of any dispute that may arise in relation to access to or use of the website, the courts and tribunals that correspond in accordance with the applicable regulations will have jurisdiction.\nWhere the user is a consumer, the mandatory rules on jurisdiction and consumer protection that apply will be respected."],
    ]},
    privacy: { title: "Privacy policy", date: "18 July 2025", sections: [
      ["Data controller", "Company name: EYE STAR SL\nTax ID (NIF): B87171740\nDomain: https://www.hotel-martorell.com/\nPostal address: Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\nEmail: administracion@hotel-martorell.com\nPhone: +34 937 745 160"],
      ["Data protection", "In accordance with current and applicable personal data protection regulations, we inform you that your data will be incorporated into the processing system owned by EYE STAR SL, with Tax ID B87171740 and registered office at Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid). The information on the processing activities carried out is provided below."],
      ["Management of online accommodation bookings", "Purpose: registration and management of online accommodation bookings.\nRetention period: 3 years (Order INT/1922/2003, of 3 July, on registration books and traveller entry records at hospitality establishments and similar).\nLegal basis: the data subject's consent.\nBasic data: name and surname, phone, Tax ID, email, financial or insurance data.\nSensitive data: data relating to minors.\nDisclosures: where necessary, your data will be communicated to the Tax Agency, banks and savings banks, Law Enforcement Agencies and the competent authorities in order to comply with the administrative and security obligations established in the applicable regulations. The legitimising basis for the disclosure is compliance with a law."],
      ["Commercial actions (web form)", "Purpose: capturing, recording and processing data to handle your enquiries and/or requests, as well as for advertising and commercial prospecting.\nRetention period: for as long as consent is maintained, unless there is a legal obligation.\nLegal basis: the data subject's consent.\nBasic data: name and surname, email."],
      ["Website user management", "Purpose: capturing, recording and processing of user data.\nRetention period: for as long as consent is maintained, unless there is a legal obligation.\nLegal basis: the data subject's consent.\nBasic data: name and surname, email."],
      ["Installation of cookies", "Purpose: management and installation of cookies.\nRetention period: for as long as consent is maintained.\nLegal basis: the data subject's consent.\nBasic data: email, IP address."],
      ["Newsletter", "Purpose: management of the newsletter subscription in order to send the relevant communications.\nRetention period: for as long as consent is maintained.\nLegal basis: the data subject's consent.\nBasic data: name and surname, email."],
      ["Web form management", "Purpose: to handle your enquiries and/or requests.\nRetention period: for as long as consent is maintained.\nLegal basis: the data subject's consent.\nBasic data: name and surname, email, IP address."],
      ["Rights of data subjects", "You may exercise your rights of access, rectification, restriction, erasure, portability and objection to the processing of your personal data, as well as the right not to be subject to automated decisions (including profiling) and to withdraw the consent given:\n• Access: obtain confirmation as to whether your data is being processed and, if so, the specific data and the legal information about the processing.\n• Rectification: have inaccurate or incomplete data corrected.\n• Restriction: have the purposes of the processing limited in certain cases.\n• Erasure: have your data deleted, except for the exceptions provided for in the GDPR.\n• Portability: receive your data in a structured, commonly used and machine-readable format and transmit it to another controller.\n• Objection: that your data not be processed or that its processing cease in the cases provided for.\n• Not to be subject to automated decisions, including profiling.\n• Withdrawal of consent: at any time and free of charge."],
      ["Exercising your rights", "To exercise these rights you may submit a written request to Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid), for the attention of EYE STAR SL, or send an email to administracion@hotel-martorell.com. The data subject must provide reliable identification; in the event of doubts about their identity, they may be asked to supplement the request. The request may be made by a legal or voluntary representative who is duly identified and authorised. The right or rights to be exercised must be specified, along with an address for notifications and any necessary supporting documents. Information will never be provided by phone."],
      ["Complaint to the supervisory authority", "You have the right to lodge a complaint with the Spanish Data Protection Agency if you believe that an act may constitute a breach of the applicable data protection regulations."],
      ["Security measures", "EYE STAR SL undertakes to adopt the technical and organisational measures necessary, in line with the level of risk of the processing carried out, so as to guarantee the integrity, confidentiality and availability of the data."],
    ]},
    cookies: { title: "Cookie policy", sections: [
      ["What they are", "Cookies are small files stored on your device while browsing that allow preferences to be remembered or site usage to be measured."],
      ["Cookies we use", "Technical cookies necessary for operation (language, admin session and remembering your cookie choice) and, only with your consent, Google Analytics 4 analytics cookies (_ga, _ga_*; maximum duration 13 months) with anonymised IP to understand how the site is used and improve it."],
      ["Third parties", "The embedded Google Maps map and the external booking engine may set their own cookies, subject to their policies."],
      ["Managing cookies", "You can configure your browser to block or delete cookies. This may affect some site features."],
      ["Managing your consent", "On your first visit you can accept, reject or configure cookies by category. You can change your choice at any time via the “Cookie settings” link in the footer. If you reject analytics cookies, Google Analytics runs in cookieless mode (Consent Mode) and only receives anonymous signals."],
    ]},
    updated: "Last updated",
  },
  consent: {
    eyebrow: "Cookies",
    title: "Your privacy, your way",
    text: "We use necessary first-party cookies and, only if you accept, analytics cookies (Google Analytics) to understand how the site is used and improve it. You can change your choice at any time via “Cookie settings” in the footer.",
    more: "Cookie policy",
    acceptAll: "Accept all",
    reject: "Reject",
    configure: "Configure",
    save: "Save selection",
    close: "Close",
    always: "Always active",
    necessary: { t: "Necessary", d: "Essential for the website to work: language, security and remembering your cookie choice." },
    analytics: { t: "Analytics", d: "Google Analytics with anonymised IP, to measure visits and improve the site. If rejected, only anonymous cookieless signals are sent." },
    marketing: { t: "Marketing", d: "To measure campaigns and personalise Google ads. We currently do not use any cookies of this kind." },
  },
  notFound: { title: "Page not found", text: "The page you are looking for does not exist or has moved.", cta: "Back to home" },
  chat: {
    open: "Hotel assistant",
    close: "Close",
    title: "Hotel assistant",
    subtitle: "Instant answers, 24/7",
    intro: "Hi, I'm the virtual assistant of Hotel Ciutat Martorell. Ask me about rooms, breakfast, how to get here, meeting rooms or events.",
    placeholder: "Type your question…",
    send: "Send",
    suggestions: ["What time is breakfast?", "How do I get there from Barcelona?", "Do you have parking?"],
    human: "Would you rather talk to a person?",
    call: "Call",
    whatsapp: "WhatsApp",
    book: "Book",
    error: "I can't answer right now. Call us on",
    disclaimer: "Automated assistant: it may make mistakes. To book, use the Book button.",
  },
  admin: {
    googleLogin: "Sign in with Google",
    or: "or",
    aiTranslate: "Translate with AI from ES",
    login: "Admin access",
    email: "Email",
    password: "Password",
    enter: "Sign in",
    logout: "Sign out",
    panel: "Content panel",
    tabs: { nye: "New Year's Eve", stats: "Statistics", ai: "AI assistant", leads: "Requests", content: "Texts", rooms: "Rooms", meeting: "Meeting rooms", faqs: "FAQs", gallery: "Gallery", blog: "Blog", survey: "Sustainability", settings: "Hotel details" },
    save: "Save",
    saved: "Saved",
    add: "Add",
    delete: "Delete",
    status: { nuevo: "New", en_proceso: "In progress", cerrado: "Closed" },
    noLeads: "No requests yet.",
    resend: "Resend alert",
    resendOk: "Alert resent to",
    resendFail: "The alert could not be sent",
    notifySent: "Email alert sent",
    notifyFailed: "Email alert failed",
    notifyUnknown: "No delivery record",
  },
  common: {
    seeMore: "See more",
    bookNow: "Book now",
    call: "Call the hotel",
    placeholderNote: "Provisional photograph",
  },
  pages: {
    rooms: {
      seoTitle: "Rooms in Martorell · 21 m² Double and Twin rooms",
      seoDesc: "Double and Twin rooms with fibre Wi-Fi, desk and buffet breakfast. Double and Twin. Book direct at the best price.",
      heroTitle: ["Rooms designed", "for real rest"],
      heroText: "92 rooms designed for the ultimate rest of business and leisure travellers.",
    },
    roomDetailSuffix: "Rooms",
    corporate: {
      seoTitle: "Business hotel and meeting rooms in Martorell",
      seoDesc: "Corporate rates, 3 meeting rooms for up to 180 people and accommodation 5 min from SEAT-CUPRA and Martorell industrial parks. Request a quote within 24 h.",
      heroTitle: ["Your base of operations", "in the Llobregat corridor"],
    },
    meetingRooms: {
      seoTitle: "Meeting and event rooms in Martorell",
      seoDesc: "3 rooms with natural light from 35 to 220 m² for meetings, training and conventions from 12 to 180 people. AV, fibre and coffee break.",
      heroTitle: ["Three rooms,", "endless layouts"],
    },
    events: {
      seoTitle: "Weddings, celebrations and groups in Martorell",
      heroTitle: ["Big days deserve", "a place to match"],
      stepsTitle: "Three steps, zero worries",
    },
    restaurant: {
      seoTitle: "Restaurant in Martorell · Mediterranean cuisine",
      heroTitle: ["Mediterranean", "market cuisine"],
    },
    location: {
      seoTitle: "Location · Hotel in Martorell 30 min from Barcelona",
      heroTitle: ["At the centre of", "everything that matters"],
      distancesTitle: "Distances and times",
    },
    gallery: {
      seoDesc: "Photographs of the 4-star Hotel Ciutat Martorell in Martorell: Double and Twin rooms, bathrooms, meeting rooms, Banquet Hall, My Bar restaurant, common areas and surroundings.",
      biosphereNote: "Hotel Ciutat Martorell holds the Biosphere sustainable tourism certification. See all our sustainability actions and commitments directly on our official profile.",
    },
    blog: { seoDesc: "Practical guides to Martorell, Barcelona and Montserrat: getting there by train or car, what to visit, where to eat and tips for business travellers and families." },
    faq: { eyebrow: "Frequently asked questions", home: "What guests usually ask us", rooms: "About the rooms", corporate: "About meetings and business stays", events: "About weddings, celebrations and groups", restaurant: "About the restaurant" },
    biosphere: { seoTitle: "Sustainability · Biosphere Certification" },
    contact: { hoursValue: "Check-in 3 pm · Check-out 12 pm" },
    seal: { sustainableTourism: "Sustainable tourism", certifiedBy: "Certified by", viewCert: "View certification" },
    bookingCta: {
      eyebrow: "Direct booking",
      rooms: { title: "Book at the best guaranteed price", text: "Booking directly on the official website gets you the best rate, with no middlemen or commissions." },
      location: { title: "30 minutes from Barcelona and Montserrat", text: "Stay next to the Renfe and FGC stations, with the airport 30 minutes away. Book direct at the best guaranteed price." },
    },
    blogPost: {
      sidebarTitle: "Sleep 100 m from the train",
      cta: {
        eyebrow: "Direct booking",
        secondary: "Request a quote",
        transport: { title: "Sleep 100 m from the train", text: "Stay next to the Renfe and FGC stations and reach Barcelona in 30 minutes. Best price guaranteed on the official website." },
        guides: { title: "Your base to discover Martorell", text: "Barcelona, Montserrat and the airport 30 minutes away. Book direct and start planning your getaway." },
        business: { title: "Accommodation and meeting rooms for your company", text: "5 minutes from the industrial area, with meeting rooms and a corporate rate. Ask us for a tailored quote." },
        default: { title: "Book your stay in Martorell", text: "4★ hotel 30 minutes from Barcelona. Best price guaranteed when you book direct." },
      },
    },
    homeHeadings: {
      presentation: ["Four-star hotel in Martorell.", "Rest, work and celebrations", "30 minutes from Barcelona."],
      gastronomy: ["Mediterranean market", "cuisine, unhurried"],
      extras: ["An event, a meeting", "or a long stay?"],
      heroRooms: "Rooms",
    },
  },
};

export default en;
